
import { granjaApi } from "../../api";
import Swal from "sweetalert2";





export const descargarPlanillaVenta = async(id) => {
    try {
        const { data } = await granjaApi.post(`/docs/planilla/`, {id}, {responseType: 'arraybuffer'});
        return data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        return false;
    }
}






